
// 所有图片后缀
const pictureSuffix = ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff', 'pdf']

//
const tMapKey = '723dd950fc4f69c37787ba1c4000dbdd'

// 未找到页面信息（即跳转404）
const notFoundPageCodes = [
  300001,
  300101,
  300201,
  300301,
  404
]

let HttpCode = {
  SUCCESS:200,  // 成功
  NOLOGIN:301,  // 登录过期
}
let AuthEnum = {
  'TOKEN':'token',
  'REFRESH_TOKEN':'refreshToken',
  'WATCH_INTERVAL':'watchInterval',
  'REFRESH_TIME':'refreshTime',
}
let HttpUrl = {
  'USER_REFRESH' : '/user/refresh'
}

// 未找到页面信息（即跳转404）
const notFoundPageRoute = [
  '/cms/site/info',
  '/cms/article/info',
  '/project/info',
  '/auction/info'
]
// 错误码信息（不需要弹错误信息）
const errorCodes = [

]

// 输入框长度限制
const _input_l_50 = 50
const _input_l_100 = 100
const _input_l_150 = 150
const _input_l_300 = 300
const _input_l_500 = 500

export {
  notFoundPageCodes,
  notFoundPageRoute,
  _input_l_50,
  _input_l_100,
  _input_l_150,
  _input_l_300,
  _input_l_500,
  pictureSuffix,
  HttpCode,
  AuthEnum,
  HttpUrl,
  tMapKey
}
